import React, { Component } from 'react';
import { 
	HeaderLogo,
	Topnav,
	TopSearch,
	TopAddShortCut,
	// TopNotification,
	TopMessages,
	Profile,
} from './HeaderInc';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import Icons from "../Icons/Icons";
import {getUserInfo,getUserTimeZone,getOrgTimeZone,checkIsModuleAvaibale,setUserAuthoritiesSession,getCurrentProfileId,
    setProfileAuthoritiesSessionEmpty,setProfileAuthoritiesSession,setUserInfoSession} from '../../Utils/UserFunctions';
import {isSet} from '../../Utils/CommonFunctions';
import { callGET, callDELETE, callDELETEREQUEST, callPUT, callPOST } from '../../Utils/ApiUtil';
import ImportSampleData from "../../Containers/Headersection/ImportSampleData";
import moment from 'moment';
import {setEmailConfigList} from '../../store/actions/formBuilderActions';
import 'moment-timezone';
// import PickyDateTime from 'react-picky-date-time';
// import Clock from 'react-clock';
import ClockCustom from './Clock';
import 'react-clock/dist/Clock.css';
import $ from 'jquery';
import { clearPreviousFilter } from '../../store/actions/GridFilterAction';
//import Test from './Test';

class Header extends Component {

	constructor(props){
        super(props);
        this.state = { 
        	userTime: moment().tz(getUserTimeZone()).toDate(),
        	orgTime: moment().tz(getOrgTimeZone()).toDate(),
        	mailAllCount : {},
        	tableRecords:{            
	            selectedRows:[],
	            tableHead:[],
	            tableData:[],
	            pagination:{
	                page:0,
	                orderBy:'createdAt',
	                perPage:5,
	                direction:true,
	                totalRecords:0,
	                search:'',
	                listId : {
	                    value : ''
	                }
	            }
	        },
            inbox_un_read:0,
            isMobileWebView:false,
            emailRefresh:false,
            lastRefreshTime:'',
        	//userDate: moment().clone().tz(getUserTimeZone()).format('MM/DD/YYYY'),
        	//userTime: moment().clone().tz(getUserTimeZone()).format('H:m:s'),        	
        	//showPickyDateTime: true,
		    //date: moment().clone().tz(getUserTimeZone()).format('DD'),
		    //month: moment().clone().tz(getUserTimeZone()).format('MM'),
		    //year: moment().clone().tz(getUserTimeZone()).format('YYYY'),
		    //hour: moment().clone().tz(getUserTimeZone()).format('H'),
		    //minute: moment().clone().tz(getUserTimeZone()).format('m'),
		    //second: moment().clone().tz(getUserTimeZone()).format('s'),
		    //meridiem: 'PM'
        };
    }

    componentWillMount = () => {
    	//console.log(getUserInfo().data.default_emailconfig_id, 'getUserInfo')	
    	this.getMailMsgCount();
        this.getUserInfo();
        this.getEmailConfig();
        this.getUserAuthorities();
        this.getProfileAuthorities();
        
    }

    /****** Email Notification *******/
    getMailMsgCount = () => {
        // console.log(getUserInfo().data.id);
		let emailConfigId = null;
		try{
			emailConfigId =isSet(getUserInfo(),{data:{default_emailconfig_id:''}}).data.default_emailconfig_id;
		}catch(e){

		}
        if(emailConfigId!==undefined){
            callGET('email/message/count?emailConfigId='+emailConfigId)
            .then(response => {
                const responseData = response.data;
                //console.log(responseData,'getMailMsgCount');
                if(responseData.code===200){
                    const updateState = {...this.state}
                    updateState.mailAllCount = responseData.data;
                    this.setState(updateState);
                    this.getEmailConfig();
                    if(responseData.data.inbox_un_read > 0){
                        
                        // console.log(responseData.data.inbox_un_read, this.state.inbox_un_read, '0000')
                        if(responseData.data.inbox_un_read!==this.state.inbox_un_read){
                            this.emailMessageList(this.state.tableRecords.pagination);
                            this.setState({inbox_un_read:responseData.data.inbox_un_read});
                        }                        
                    }else{
                        const totalRecords = 0;//response.data.totalElements;
                        this.setState({status:200, tableRecords:{
                            selectedRows:[],
                            tableData:[],
                            tableHead:[],
                            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
                        }});    
                    }
                }else{
                }
            })
            .catch(err => {
                console.log(err);
                //this.props.failMessage('Something went wrong');
            });    
        }
        
    }

    getUserInfo = () => {
        callGET('users/info')
        .then(reponse => {
            const responseData = reponse.data;
            if(responseData.code === 200) { 
                setUserInfoSession(responseData);
            }
        })
        .catch(err => {
          console.log(err);
        })
    }
    //getMailConfig data
    getEmailConfig =()=>{
        let APIURL = 'email/config/search?default=true';
        callGET(APIURL)                                     
        .then(res => {
            if(res.status===200){ 
                const response = res.data;
                if(response.code===200){
                    // console.log(JSON.stringify(response.data), 'response.data')
                    if(response.data!==null){
                        if(response.data!==this.props.emailConfigList){
                            this.props.setEmailConfigList(response.data)  
                        }
                    }
                }
            }          
        },(error) => {
            console.log(error);
        })
    }

    //refresh button function 
    refreshHandler = () => {
        this.setState({emailRefresh:true})
        const updateState = { ...this.state };        
        updateState.tableRecords.pagination.search= '';
        updateState.tableRecords.pagination.page= 0;                     
        this.setState(updateState);    
        this.emailMessageList(updateState.tableRecords.pagination,true);
        this.getEmailConfig();
    }

    /*Get Profile Authorities*/
    getProfileAuthorities = () => {
      const profile_id = getCurrentProfileId();
    //   setProfileAuthoritiesSessionEmpty()
      callGET('profiles/'+profile_id)
      .then(response => {
        const responseData = response.data;
        if(responseData.code === 200) { 
          setProfileAuthoritiesSession(responseData);
        }else{
            setProfileAuthoritiesSessionEmpty();
        }
      })
      .catch(err => {
          console.log(err);
          //this.props.Loader(false);
      })
    }

    getUserAuthorities = () => {
        callGET('users/userAuthorities')
        .then(response => {
            const responseData = response.data;
            if(responseData.code === 200) { 
                setUserAuthoritiesSession(responseData);
                // let currModId = '';
                // const userDefaultMod = userData.data.user_preference.default_module;     
                // responseData.data.map((arr,ind) => {
                //  if(userDefaultMod === arr.module_name) {
                //      currModId = arr.module_id;
                //  }
                // })
                /*setCurrentModuleId(currModId);
                this.getProfileAuthorities();*/
                // this.props.leftMenuGenerateHandler(currModId);
            }else {
                // this.props.Loader(false);
            }
            // console.log(response);
        })
        .catch(err => {
          console.log(err);
          // this.props.Loader(false);
        })
    }

    emailMessageList = (pagination, refresh="false") => {
    	const page = pagination.page; 
        const orderBy = pagination.orderBy; 
        const perPage = pagination.perPage; 
        //const direction = pagination.direction; 
        const direction = false; 
        const search = pagination.search;
        const emailPage = this.state.emailName;
        const emailConfigId = getUserInfo().data.default_emailconfig_id;
        let messagePlaceholder = 'INBOX';
        const url = "email/message/search?messagePlaceholder="+messagePlaceholder;
        let queryString = '';
        let extraParam = '&un_read_only=true';
        queryString = '&refresh='+refresh+'&emailConfigIds='+emailConfigId+'&query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&sortAsc='+direction+extraParam;
        callGET(url+queryString)
        .then(res => {
        	if(res.status===200){
        		const response = res.data;
        		if(response.code===200){
        			if(response.data){
        				let itemDataNew = response.data.content;
        				let updateTableData = [];
        				itemDataNew.map((item,index)=>{                             
                            let ss = { 
                                rowId: item.id,
                                message_date: item.created_at,
                                subject: item.subject,
                                body: item.body,
                                message_group_id: item.message_group_id,
                                itemData:item 
                            }
                            updateTableData.push(ss);
                            const totalRecords = response.data.total_elements;
                            this.setState({status:200, tableRecords:{
                                selectedRows:[],
                                tableData:{data:updateTableData,status:200},
                                tableHead:[],
                                pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
                            }});
                        })
        			}else{
        				const totalRecords = 0;//response.data.totalElements;
        				this.setState({status:200, tableRecords:{
                            selectedRows:[],
                            tableData:[],
                            tableHead:[],
                            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
                        }});
        			}
        		}else{
        			const totalRecords = 0;//response.data.totalElements;
                    this.setState({status:200, tableRecords:{
                        selectedRows:[],
                        tableData:[],
                        tableHead:[],
                        pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
                    }});
        		}
        	}
        },(error) => {
            //if(loadtype!==0) { this.props.Loader(); }
            this.props.failMessage('Something wrong on Message Listing!!!');
            console.log(error);
        })
    }

    callEamilMarkAsRealAllHandler = () => {
    	//console.log('callEamilMarkAsRealAllHandler')
    	this.props.Loader();
    	let body = [];
    	const emailConfigId = getUserInfo().data.default_emailconfig_id;
        body.push(emailConfigId)
        callPOST('email/messages/mark-as-read', body)
        .then((response) => {
            this.props.Loader();
            const responseData = response.data;
            if(responseData.code === 200) {                                            
                this.props.succMessage(responseData.message);
                this.emailMessageList(this.state.tableRecords.pagination);
                this.setState({inbox_un_read:0});                
            }else {                    
                this.props.failMessage(responseData.message);
            }                    
        }, (error) => {
            this.props.Loader();
            this.props.failMessage('Error occured while on operation');
            console.log(error);
        });
    }

    /************/   


	componentDidMount(){
        this.timer = setInterval(
        	// console.log('')
            () => {
            	let convertUserTime = new Date().toLocaleString("en-US", { timeZone: getUserTimeZone() });
  				let userTimeClock = new Date(convertUserTime);
  				let convertOrgTime = new Date().toLocaleString("en-US", { timeZone: getOrgTimeZone() });
  				let orgTimeClock = new Date(convertOrgTime);

  				this.setState({
	            	//userTime: moment().tz(getUserTimeZone()).format('dd MM D YYYY H:mm:ss'),//new Date(),
	            	//userTime: new Date(),
	            	userTime: userTimeClock,
	            	orgTime: orgTimeClock
	            	//userTime: new Date().toLocaleString("en-US", {timeZone: getUserTimeZone()}),
	            	//orgTime: new Date().toLocaleString("en-US", {timeZone: getOrgTimeZone()}),
	            	//userTime: moment().clone().tz(getUserTimeZone()).toLocaleString(),
	            	//orgTime: moment().clone().tz(getOrgTimeZone()).toLocaleString()
	            })
            }, 1000 
        );

        // this.timer = setInterval(


        // 	//let userTime = this.state.userTime

        //     () => {
        //     	//console.log('sss')

        //     	let timeGet = this.state.userTime.split(':');
        //     	console.log(timeGet[2] , 'timeGet')

        //     	this.setState({
	       //      	userTime: moment().clone().tz(getUserTimeZone()).format('H:m:s'),
	       //      	hour:timeGet[0],            	
	       //      	minute:timeGet[1],            	
	       //      	second:timeGet[2]            	
	       //      })
        //     },
        //     1000
        // );
        // alert(moment().tz(getUserTimeZone()).format());
        // alert(getUserTimeZone());
        // alert(moment().tz(getUserTimeZone()).format());
        //alert(moment().tz('America/New_York').format());
        //console.log(moment().tz(getUserTimeZone()).toLocaleString(),'===', new Date(), ' === ', moment().tz('Asia/Kathmandu').toLocaleString(), '===',getUserTimeZone()) 
 
        this.timerForEmailNotification = setInterval(
        	() => {
        		//console.log('timerForEmailNotification', this.state.mailAllCount.inbox_un_read)
        		// this.getMailMsgCount();
                // this.getEmailConfig();
                
        	},60000
        );


        //window resize
        window.addEventListener("resize", this.updateDimensions);
        this.updateDimensions();
      
    }
    //when change window from top shortcut
     clearFilter = (windowName) => {
        if(this.props.windowName!==windowName){
        this.props.clearPreviousFilter()
        }
       }
	componentWillUnmount(){
        clearInterval(this.timer);
        clearInterval(this.timerForEmailNotification);
    }

    updateDimensions = ()=>{
        if ($(window).width() < 992) {
            //console.log('window min')
            this.setState({isMobileWebView:true,})
            //$('#splitView_sidebar').addClass('active');
        } else {
            //$('#splitView_sidebar').removeClass('active');
            //console.log('window max')
            this.setState({isMobileWebView:false,})
        }
    }

    marketPlace = () => {
        this.props.history.push("/market-place");
    }

	render() {
	const userInfo = getUserInfo();
    const {emailConfigList} = this.props;
	// console.log(this.state)
	const {mailAllCount,inbox_un_read} = this.state;
	let hideMailcount = "hide";
	if(inbox_un_read > 0){
		hideMailcount = '';
	}

    const today = new Date();
    const todayY = today.getFullYear();
    const todayM = today.getMonth() + 1;
    const todayD = today.getDate();
    // console.log('userTime',userTime);
    let convertUserTime = new Date().toLocaleString("en-US", { timeZone: getUserTimeZone() });
    let userTimeClock = new Date(convertUserTime);
    let convertOrgTime = new Date().toLocaleString("en-US", { timeZone: getOrgTimeZone() });
    let orgTimeClock = new Date(convertOrgTime);        
    let displayUserTime = userTimeClock.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    let displayOrgTime = orgTimeClock.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
	return (
		<div className="main-header">
			<HeaderLogo {...this.props} isMobileView={this.state.isMobileWebView} />
			<nav className="navbar navbar-header navbar-expand-lg" >
				<div className="container-fluid">
                    {
                        this.state.isMobileWebView === false?
                        <Topnav isMobileView={this.state.isMobileWebView} leftMenuGenerate={this.props.leftMenuGenerate} changeModuleHandler={this.props.changeModuleHandler}/>
                        :
                        <></>
                    }
					
                    { checkIsModuleAvaibale('Manage Tags') === true ? 
					<TopSearch {...this.props} isSearchVisible={true}/>
                    : null }
					<ul className="navbar-nav topbar-nav  align-items-center">
						 
 						<li className="nav-item focus dropdown hidden-caret svgIconFill d-none d-lg-block" style={{borderRight:'1px solid #677076', paddingRight:'20px'}}>
 
                            <a className="nav-link cursor-pointer topPlus" data-toggle="dropdown" aria-expanded="false" style={{backgroundColor:'#ff6b32'}}>                                
                                <Icons iconType="IconPlus" size={22} color={'#FFFFFF'}/>                                
                            </a>
                            <TopAddShortCut windowData={this.props.windowData} clearFilter={this.clearFilter}/>
                        </li>
						<li className="nav-item focus dropdown hidden-caret svgIconFill svgTop">
							<a className="nav-link cursor-pointer dropdown-toggle" data-toggle="dropdown"   aria-expanded="false">								
								<Icons iconType="IconTimeZone" />
							</a>
							<div className="dropdown-menu animated fadeIn" style={{"maxWidth":"fit-content"}}>
                                <div className="d-flex align-items-center justify-content-center">
								<div className="p-2 px-3 label-align-center">
									<span className="navi-text text-medium" style={{"width":"130px"}}> User Time </span>									
									<ClockCustom size={200} timeFormat="24hour" hourFormat="standard" clockFor="userTime" fillText={getUserTimeZone()} />		
								    <span className="text-small text-info"> {displayUserTime} </span>
                                </div>
								<div className="p-2 px-3 label-align-center">
                                    <span className="navi-text text-medium" style={{"width":"130px"}}> Organization Time </span>
									<ClockCustom size={200} timeFormat="24hour" hourFormat="standard" clockFor="orgTime" fillText={getOrgTimeZone()} />			
								    <span className="text-small text-info"> {displayOrgTime} </span>
                                </div>
								 
								{/*<li>
									<PickyDateTime
								        size="xs"// 'xs', 's', 'm', 'l'
								        mode={2} //0: calendar only, 1: calendar and clock, 2: clock only; default is 0
								        locale={`en-us`}// 'en-us' or 'zh-cn'; default is en-us
								        show={showPickyDateTime} //default is false
								        defaultTime={`${hour}:${minute}:${second} ${meridiem}`} // OPTIONAL. format: "HH:MM:SS AM"
        								defaultDate={`${month}/${date}/${year}`} // OPTIONAL. format: "MM/DD/YYYY"
								        onClose={() => this.setState({ showPickyDateTime: false })}
								        onYearPicked={res => this.onYearPicked(res)}
										onMonthPicked={res => this.onMonthPicked(res)}
										onDatePicked={res => this.onDatePicked(res)}
										onResetDate={res => this.onResetDate(res)}
										onSecondChange={res => this.onSecondChange(res)}
										onMinuteChange={res => this.onMinuteChange(res)}
										onHourChange={res => this.onHourChange(res)}
										onMeridiemChange={res => this.onMeridiemChange(res)}
										onResetTime={res => this.onResetTime(res)}
										onClearTime={res => this.onClearTime(res)}
								        //markedDates={['11/18/2021']} // OPTIONAL. format: "MM/DD/YYYY"
								      />
								</li> 
								<li>
									<div className="dropdown-title"> Time Zone </div>
								</li>
								<li>
									<div className="scroll-wrapper notif-scroll scrollbar-outer">
										<h6>User Time</h6>
										 <div className="text-small p-2 text-danger" id="clock"> {this.state.userTime}</div>
									</div>
									<div className="scroll-wrapper notif-scroll scrollbar-outer">
										<h6 className="p-0">Organization Time</h6>
										 <div className="text-small p-2 pt-0 text-danger" id="clock"> {this.state.orgTime}</div>
									</div>
								</li>*/} 

                                </div>
							</div>
						</li>
						<li className="nav-item focus toggle-nav-search hidden-caret" >
							<a style={{"color":"#a1a5b7"}} className="nav-link" data-toggle="collapse" href="#search-nav" role="button" aria-expanded="false" aria-controls="search-nav">
								<svg width="24" height="24" viewBox="0 0 24 24" fill="#a1a5b7">
                                    <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="#a1a5b7"></rect>
                                    <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="#a1a5b7"></path>
                                </svg>
							</a>
						</li>

						

						{/*<li className="nav-item dropdown hidden-caret svgIconFill svgTop">
							<a className="nav-link cursor-pointer dropdown-toggle" data-toggle="dropdown"   aria-expanded="false">								
								<Icons iconType="IconBell" />
							</a>

							<TopNotification />
						</li>*/}
						<li className="nav-item focus dropdown hidden-caret svgIconFill svgTop">
							<a className="nav-link dropdown-toggle cursor-pointer"   role="button" data-toggle="dropdown"  aria-expanded="false">
								<Icons iconType="IconMessage" />
								<span className={`notification ${hideMailcount}`}>{inbox_un_read}</span>								
							</a>

							<TopMessages 
                                emailRefresh={this.state.emailRefresh} 
                                emailConfigList={emailConfigList} 
                                userInfo={userInfo} tableRecords={this.state.tableRecords} 
                                refreshHandler ={this.refreshHandler}
                                lastRefreshTime={this.state.lastRefreshTime} 
                                callEamilMarkAsRealAllHandler={this.callEamilMarkAsRealAllHandler} />
						</li>

                        {/*Marketplace*/}
                        <li className="nav-item focus dropdown hidden-caret svgIconFill svgTop" onClick={this.marketPlace}>
                            <a className="nav-link dropdown-toggle cursor-pointer"   role="button" data-toggle="dropdown"  aria-expanded="false">
                                <Icons iconType="MarketPlaceIcon" />
                            </a>
                        </li>                        
					  	
					  	<li className="nav-item focus dropdown hidden-caret svgIconFill svgTop d-none d-lg-block">
							<a className="nav-link dropdown-toggle cursor-pointer" data-toggle="dropdown"  aria-expanded="false">								
								<Icons iconType="IcontopUser" />

								{/*
								<div className="avatar-sm">
									<img src="/assets/img/profile2.jpg" alt="..." className="avatar-img rounded-circle" />
								</div>
								*/}
							</a>
							
							<Profile userInfo={userInfo} {...this.props} />
						</li>

						 
					</ul>
				</div>
			</nav>
			<ImportSampleData />
		</div>
	);
	}
}
const mapStateToProps = (state) => { 

	return {  
	  emailConfigList:state.formBuilder.emailConfigList,
       windowName:state.formBuilder.windowName
	};
  }
const mapDispatchToProps = dispatch => {
    return {
      Loader : () => dispatch(actions.loader()),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg)) ,
      setEmailConfigList:(obj)=>dispatch(setEmailConfigList(obj)),
      clearPreviousFilter:()=>dispatch(clearPreviousFilter()),

    };
  }
export default
    connect(
        mapStateToProps, 
      mapDispatchToProps
    )(withRouter(Header));

//export default Header;


